<template>

    <div id="AddPostPage">
        <navigation/>


        <centered-card headline="Post a Video">
            <post-form/>

            <hr>
            <favlet/>
        </centered-card>

    </div>
</template>

<script>

    import Navigation from '../layout/MainNavigation.vue';
    import CenteredCard from '../layout/CenteredCard.vue';
    import PostForm from './AddPostForm.vue';

    import Favlet from '../ui/ShareBookmarklet.vue';


    export default {
        name: 'AddPostPage',
        metaInfo: {
            title: 'Post a Video'
        },
        data() {
            return {

            }
        },
        methods: {

        },
        components: {
            Navigation,
            CenteredCard,
            PostForm,

            Favlet

        }
    }
</script>

<style lang="sass" scoped>


</style>


// WEBPACK FOOTER //
// src/components/posts/AddPostPage.vue